const CONSTS = {
  MARKDOWN: {
    PREFIX: '#md#',
    SUFFIX: '#/md#',
  },

  /* eslint-disable max-len */
  // See: https://gist.github.com/dperini/729294, the same regexp is used in old agent UI
  URL_REGEXP:
    // protocol identifier required
    '(?:(?:(?:https?|ftp):)\\/\\/)' +
    // user:pass BasicAuth (optional)
    '(?:\\S+(?::\\S*)?@)?' +
    '(?:' +
      // IP address exclusion
      // private & local networks
      '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
      '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
      '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
      // IP address dotted notation octets
      // excludes loopback network 0.0.0.0
      // excludes reserved space >= 224.0.0.0
      // excludes network & broadcast addresses
      // (first & last IP address of each class)
      '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
      '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
      '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
    '|' +
      // host & domain names, may end with dot
      '(?:' +
        '(?:' +
          '[a-z0-9\u00a1-\\uffff]' +
          '[a-z0-9\u00a1-\\uffff_-]{0,62}' +
        ')?' +
        '[a-z0-9\u00a1-\\uffff_-]\\.' +
      ')+' +
      // TLD identifier name, may end with dot
      '(?:[a-z0-9\u00a1-\\uffff_-]{2,}\\.?)' +
    ')' +
    // port number (optional)
    '(?::\\d{2,5})?' +
    // resource path (optional)
    '(?:[/?#]\\S*)?',
  /* eslint-enable max-len */
  HTML_TAGS_REGEXP: '<[^>]*>',

  LE_EDITOR: {
    SUPPORTED_QUILL_FORMATS: {
      BOLD: 'bold',
      ITALIC: 'italic',
      LE_QUILL_LINK: 'leQuillLink',
      LE_QUILL_AUTOCOMPLETE: 'leQuillAutocomplete',
      UNDERLINE: 'underline',
      DIRECTION: 'direction',
      ALIGN: 'align',
    },
    SUPPORTED_HTML_ELEMENTS: {
      STRONG: 'strong',
      I: 'i',
      U: 'u',
      A: 'a',
      BR: 'br',
      SPAN: 'span',
    },
    WRITE_DIRECTION: {
      LTR: 'ltr',
      RTL: 'rtl',
      AUTO: 'auto',
    },
    WRITE_ALIGN: {
      LEFT: 'left',
      RIGHT: 'right',
    },
    LINE_HEIGHT: 18,
    MIN_ROWS: 3,
    MAX_ROWS: 11,
  },
  LE_DIALOG: {
    VARIANTS: {
      WARNING: 'warning',
      ERROR: 'error',
    },
  },
  LE_BUBBLE: {
    PLACEMENTS: {
      AUTO: 'auto-center',
      AUTO_START: 'auto-start',
      AUTO_END: 'auto-end',
      TOP: 'top-center',
      TOP_START: 'top-start',
      TOP_END: 'top-end',
      RIGHT: 'right-center',
      RIGHT_START: 'right-start',
      RIGHT_END: 'right-end',
      BOTTOM: 'bottom-center',
      BOTTOM_START: 'bottom-start',
      BOTTOM_END: 'bottom-end',
      LEFT: 'left-center',
      LEFT_START: 'left-start',
      LEFT_END: 'left-end',
    },
    THEMES: {
      DARK: 'dark',
    },
  },
  LE_TABLE: {
    SORT_DIRECTION: {
      DESC: 'desc',
      ASC: 'asc',
    },
    EMPTY_ORIENTATION: {
      HORIZONTAL: 'horizontal',
      VERTICAL: 'vertical',
    },
    ROW_HEIGHT: 60,
    HEADER_HEIGHT: 55,
  },
  LE_TABS: {
    VARIANTS: {
      PRIMARY: 'primary',
      DEFAULT: 'default',
    },
  },
  LE_BUTTON: {
    VARIANTS: {
      DEFAULT: 'default',
      PRIMARY: 'primary',
      LINK: 'link',
      CANCEL: 'cancel',
    },
    SIZE: {
      SMALL: 'small',
      DEFAULT: 'default',
      LARGE: 'large',
    },
  },
  LE_CHECKBOX: {
    STATES: {
      UNCHECKED: 'unchecked',
      CHECKED: 'checked',
      INDETERMINATE: 'indeterminate',
    },
  },
  LE_SELECT_CONSTS: {
    TYPE: {
      MULTISELECT: 'multiselect',
      SINGLESELECT: 'singleselect',
      DROPDOWN: 'dropdown',
      MENU: 'menu',
      LIST_ONLY: 'listOnly',
    },
    BUBBLE_LIST_ALIGN: {
      LEFT: 'left',
      RIGHT: 'right',
    },
    ERRORS: {
      SINGLE_SELECT: {
        INVALID_ITEM: 'Please select an item from the list.',
      },
      MULTI_SELECT: {
        INVALID_ITEM: 'Please select an item from the list.',
        UNFINISHED_CREATE: 'press ENTER to submit your changes.',
      },
    },
  },
  LE_DATE_CONSTS: {
    TYPE: {
      DATE_INPUT_FIELD: 'dateInputField',
      DATE_AND_TIME_PICKER: 'dateAndTimePicker',
    },
  },
  LE_INPUT_FIELD: {
    TYPE: {
      TEXT: 'text',
      SEARCH: 'search',
      POSITIVE_INTEGER_OR_ZERO: 'positiveIntegerOrZero',
      NEGATIVE_OR_POSITIVE_FLOAT_OR_ZERO: 'negativeOrPositiveFloatOrZero',
      NEGATIVE_OR_POSITIVE_INTEGER_OR_ZERO: 'negativeOrPositiveIntegerOrZero',
    },
  },
  HOUR_FORMATS: {
    AM_PM: '12',
    24: '24',
  },
  // This is similar to AMSStatics.participant.roles, this is constant because we don't want to be tied to AMSStatics
  ROLES: {
    AGENT: 'AGENT',
    ASSIGNED_AGENT: 'ASSIGNED_AGENT',
    CONSUMER: 'CONSUMER',
    CONTROLLER: 'CONTROLLER',
    MANAGER: 'MANAGER',
    READER: 'READER',
  },
  // This is similar to AMSStatics.eventTypes, this is constant because we don't want to be tied to AMSStatics
  EVENT_TYPES: {
    ACCEPT_STATUS: 'AcceptStatusEvent',
    CHAT_STATE: 'ChatStateEvent',
    CONTENT: 'ContentEvent',
    RICH_CONTENT: 'RichContentEvent',
  },
  KEYBOARD_KEYS: {
    TAB: 'Tab',
    ARROW_RIGHT: 'ArrowRight',
    SPACE: ' ',
  },
  KEY_CODES: {
    TAB: 9,
    ARROW_RIGHT: 39,
    SPACE: 32,
  },
};

export default CONSTS;
